import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  Typography,
  Grid,
  Stack,
  Button,
  LinearProgress,
} from "@mui/material";

import {

  Popover,
  Checkbox,
  FormControlLabel,
  Divider,
  Radio,
  RadioGroup,
} from "@mui/material";
import {
  CheckCircle,
  ErrorOutline,
  WarningAmber,
  Cancel,
  BatteryAlert,
  SignalCellularConnectedNoInternet4Bar,
  WifiOff,
  Whatshot,
  FilterList,
  DeviceThermostat,
  Lock,
  Sensors,
  TrendingUp
} from "@mui/icons-material";
import Pagination from "@mui/material/Pagination";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
} from "@mui/material";
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

const cards = [
  {
    title: "Good Health",
    value: "1,247",
    count: "+12%",
    countColor: "#16a34a",
    bg: "#ECFDF5",
    icon: <CheckCircle sx={{ color: "#16a34a" }} />,
  },
  {
    title: "Fair Health",
    value: "342",
    count: "+5%",
    countColor: "#ca8a04",
    bg: "#FEFCE8",
    icon: <ErrorOutline sx={{ color: "#ca8a04" }} />,
  },
  {
    title: "Poor Health",
    value: "89",
    count: "+8%",
    countColor: "#ea580c",
    bg: "#FFF7ED",
    icon: <WarningAmber sx={{ color: "#ea580c" }} />,
  },
  {
    title: "Critical",
    value: "23",
    count: "+3%",
    countColor: "#dc2626",
    bg: "#FEF2F2",
    icon: <Cancel sx={{ color: "#dc2626" }} />,
  },
];

const alerts = [
  {
    title: "Low Battery",
    device: "Device #47321",
    time: "2 mins ago",
    icon: <BatteryAlert sx={{ color: "#ef4444" }} />,
    bg: "#FEF2F2",
  },
  {
    title: "Weak Signal",
    device: "Device #113283",
    time: "6 mins ago",
    icon: (
      <SignalCellularConnectedNoInternet4Bar sx={{ color: "#f59e0b" }} />
    ),
    bg: "#FFFBEB",
  },
  {
    title: "Lost Connectivity",
    device: "Device #15627",
    time: "14 mins ago",
    icon: <WifiOff sx={{ color: "#ef4444" }} />,
    bg: "#FEF2F2",
  },
  {
    title: "High Temperature",
    device: "Device #664510",
    time: "29 mins ago",
    icon: <Whatshot sx={{ color: "#ef4444" }} />,
    bg: "#FEF2F2",
  },
];
const chartData = [
  { date: "Jan 20", good: 1200, fair: 400, poor: 300, critical: 200 },
  { date: "Jan 21", good: 1100, fair: 420, poor: 310, critical: 210 },
  { date: "Jan 22", good: 800, fair: 390, poor: 320, critical: 220 },
  { date: "Jan 23", good: 900, fair: 410, poor: 280, critical: 180 },
  { date: "Jan 24", good: 950, fair: 320, poor: 260, critical: 150 },
];

const next30DaysData = [
  {
    device: "Device #47821",
    location: "Building A",
    percent: "82%",
    percentColor: "#f97316",
    timeAgo: "2 mins ago",
    schedule: "2 am",
    icon: <DeviceThermostat sx={{ color: "#22c55e" }} />,
    bg: "#EAF7F1",
  },
  {
    device: "Device #73283",
    location: "Device 6",
    percent: "72%",
    percentColor: "#fb923c",
    timeAgo: "6 mins ago",
    schedule: "3 am",
    icon: <Lock sx={{ color: "#facc15" }} />,
    bg: "#FFF7ED",
  },
  {
    device: "Device #15627",
    location: "Building D",
    percent: "54%",
    percentColor: "#22c55e",
    timeAgo: "5 mins ago",
    schedule: "3 am",
    icon: <Sensors sx={{ color: "#3b82f6" }} />,
    bg: "#EFF6FF",
  },
  {
    device: "Device #66541",
    location: "Building B",
    percent: "68%",
    percentColor: "#f97316",
    timeAgo: "12 mins ago",
    schedule: "1 am",
    icon: <DeviceThermostat sx={{ color: "#f97316" }} />,

    bg: "#FFF7ED",
  },
];

const devices = [
  {
    id: "#41621",
    status: "Good",
    statusColor: "#22c55e",
    statusBg: "#EAF7F1",
    building: "Building A",
    health: "92%",
    signal: "+42 dBm",
    temperature: "41°C",
    lastSeen: "7 mins ago",
  },
  {
    id: "#47821",
    status: "Critical",
    statusColor: "#ef4444",
    statusBg: "#FEF2F2",
    building: "Building C",
    health: "8%",
    signal: "+68 dBm",
    temperature: "41°C",
    lastSeen: "7 mins ago",
  },
  {
    id: "#62934",
    status: "Poor",
    statusColor: "#f97316",
    statusBg: "#FFF7ED",
    building: "Building B",
    health: "52%",
    signal: "+79 dBm",
    temperature: "39°C",
    lastSeen: "3 mins ago",
  },
  {
    id: "#10532",
    status: "Good",
    statusColor: "#22c55e",
    statusBg: "#EAF7F1",
    building: "Building D",
    health: "84%",
    signal: "+51 dBm",
    temperature: "47°C",
    lastSeen: "5 mins ago",
  },
];

export default function HealthMonitor() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isMobile]);

  const [tab, setTab] = useState("all");
  //   const filteredDevices =
  //     tab === "all"
  //       ? devices
  //       : devices.filter((device) => device.status.toLowerCase() === tab);
  const [page, setPage] = useState(1);
  const totalPages = 3;
  const riskScore = 63;

  const [anchorEl, setAnchorEl] = useState(null);

  const [statusFilter, setStatusFilter] = useState([]);
  const [buildingFilter, setBuildingFilter] = useState([]);
  const [lastSeen, setLastSeen] = useState("");
  const [temperature, setTemperature] = useState("");

  const open = Boolean(anchorEl);

  const [appliedFilters, setAppliedFilters] = useState({
    status: [],
    building: [],
    lastSeen: "",
    temperature: "",
  });

const minutesAgo = (text) => {
  if (!text) return Infinity;
  if (text.includes("min")) return parseInt(text);
  if (text.includes("hour")) return parseInt(text) * 60;
  return Infinity;
};


  const filteredDevices = devices.filter((device) => {

  // ✅ TAB FILTER
  if (tab !== "all" && device.status.toLowerCase() !== tab) {
    return false;
  }

  // ✅ STATUS FILTER
  if (
    appliedFilters.status.length > 0 &&
    !appliedFilters.status.includes(device.status)
  ) return false;

  // ✅ BUILDING FILTER
  if (
    appliedFilters.building.length > 0 &&
    !appliedFilters.building.includes(device.building)
  ) return false;

  // ✅ LAST SEEN FILTER (FIXED)
  const mins = minutesAgo(device.lastSeen);
  if (appliedFilters.lastSeen === "15m" && mins > 15) return false;
  if (appliedFilters.lastSeen === "1h" && mins > 60) return false;
  if (appliedFilters.lastSeen === "offline" && mins <= 60) return false;

  // ✅ TEMPERATURE FILTER (FIXED)
  const temp = parseInt(device.temperature.replace("°C", ""));
  if (appliedFilters.temperature === "normal" && temp >= 40) return false;
  if (
    appliedFilters.temperature === "warning" &&
    (temp < 40 || temp > 45)
  ) return false;
  if (appliedFilters.temperature === "high" && temp <= 45) return false;

  return true;
});


  return (
    <Box p={isMobile ? 1 : 3} mt={isMobile ? "2rem" : 0}>
      <Grid container spacing={3} alignItems="stretch">
        {cards.map((card, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card
              sx={{
                p: 3,
                width: isMobile ? "280px" : "150px",
                borderRadius: "16px",
                boxShadow: "0px 4px 16px rgba(0,0,0,0.06)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              {/* Top section */}
              <Box display="flex" justifyContent="space-between">
                <Box
                  sx={{
                    width: 52,
                    height: 52,
                    borderRadius: "12px",
                    backgroundColor: card.bg,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {card.icon}
                </Box>

                <Typography
                  sx={{
                    color: card.countColor,
                    fontWeight: 600,
                    fontSize: "14px",
                  }}
                >
                  {card.count}
                </Typography>
              </Box>

              {/* Bottom section */}
              <Box>
                <Typography sx={{ mt: 2, color: "#6b7280", fontSize: "14px" }}>
                  {card.title}
                </Typography>

                <Typography
                  sx={{
                    mt: 0.5,
                    fontSize: "22px",
                    fontWeight: 700,
                    color: "#111827",
                  }}
                >
                  {card.value}
                </Typography>
              </Box>
            </Card>
          </Grid>
        ))}
        <Card
          sx={{
            mt: 3,
            mb: 4,
            p: isMobile ? 2 : 3,
            borderRadius: "16px",
            boxShadow: "0px 4px 16px rgba(0,0,0,0.06)",
            width: "100%",
          }}
        >
          {/* Header */}
          <Box mb={2}>
            <Typography fontWeight={700} fontSize="16px" sx={{ mb: 0.5 }}>
              Health Analytics
            </Typography>
            <Stack
              direction="row"
              spacing={3}
              alignItems="center"
              mt={0.5}
              flexWrap="wrap"
            ></Stack>
            <Typography color="text.secondary" fontSize="14px">
              System Health: <b>87%</b> &nbsp;|&nbsp; Avg Signal: <b>-61 dBm</b>{" "}
              &nbsp;|&nbsp; Avg Temp: <b>41°C</b>
            </Typography>
          </Box>

          {/* Chart */}
          <Box
            sx={{
              width: isMobile ? "100%" : "100%",
              height: isMobile ? 260 : 320,
            }}
          >
            <ResponsiveContainer width="100%" height="100%">
              <AreaChart data={chartData}>
                <defs>
                  <linearGradient id="good" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor="#22c55e" stopOpacity={0.4} />
                    <stop offset="95%" stopColor="#22c55e" stopOpacity={0} />
                  </linearGradient>

                  <linearGradient id="fair" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor="#facc15" stopOpacity={0.4} />
                    <stop offset="95%" stopColor="#facc15" stopOpacity={0} />
                  </linearGradient>

                  <linearGradient id="poor" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor="#fb923c" stopOpacity={0.4} />
                    <stop offset="95%" stopColor="#fb923c" stopOpacity={0} />
                  </linearGradient>

                  <linearGradient id="critical" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor="#ef4444" stopOpacity={0.4} />
                    <stop offset="95%" stopColor="#ef4444" stopOpacity={0} />
                  </linearGradient>
                </defs>

                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                <XAxis dataKey="date" />
                <YAxis />
                <Tooltip />
                <Legend verticalAlign="bottom" height={36} />

                <Area
                  type="monotone"
                  dataKey="good"
                  stroke="#22c55e"
                  fill="url(#good)"
                />
                <Area
                  type="monotone"
                  dataKey="fair"
                  stroke="#facc15"
                  fill="url(#fair)"
                />
                <Area
                  type="monotone"
                  dataKey="poor"
                  stroke="#fb923c"
                  fill="url(#poor)"
                />
                <Area
                  type="monotone"
                  dataKey="critical"
                  stroke="#ef4444"
                  fill="url(#critical)"
                />
              </AreaChart>
            </ResponsiveContainer>
          </Box>
        </Card>
        <Card
          sx={{
            p: isMobile ? 3 : 2,
            borderRadius: 4,
            height: "430px",
            width: isMobile ? "100%" : "250px",
          }}
        >
          {/* Header */}
          <Typography fontWeight={700} fontSize="14px" mb={2}>
            CRITICAL ALERTS
          </Typography>

          {/* Alerts List */}
          <Stack spacing={1.5}>
            {alerts.map((alert, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  gap: 1.5,
                  p: 1.5,
                  borderRadius: "12px",
                  backgroundColor: alert.bg,
                  alignItems: "center",
                }}
              >
                {/* Icon */}
                <Box
                  sx={{
                    width: 36,
                    height: 36,
                    borderRadius: "10px",
                    backgroundColor: "#ffffff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0px 2px 8px rgba(0,0,0,0.06)",
                  }}
                >
                  {alert.icon}
                </Box>

                {/* Text */}
                <Box>
                  <Typography fontWeight={600} fontSize="13px">
                    {alert.title}
                  </Typography>

                  <Typography fontSize="12px" color="text.secondary">
                    {alert.device}
                  </Typography>

                  <Typography fontSize="11px" color="text.secondary">
                    {alert.time}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Stack>

          {/* Footer */}
          <Button
            fullWidth
            sx={{
              mt: 2,
              textTransform: "none",
              fontSize: "13px",
              color: "#2563eb",
            }}
          >
            View All Alerts
          </Button>
        </Card>
        <Card
          sx={{
            p: isMobile ? 3 : 2,
            borderRadius: 4,
            // height: "380px",
            // width: isMobile ? "100%" : "250px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "430px",
            width: isMobile ? "100%" : "250px",
          }}
        >
          {/* Header */}
          <Typography fontWeight={700} fontSize="14px">
            RISK LEVEL
          </Typography>

          {/* Gauge */}
          <Box textAlign="center" mt={2}>
            <Typography fontSize="32px" fontWeight={700} color="#f97316">
              {riskScore}%
            </Typography>

            <Typography fontSize="13px" color="text.secondary">
              Medium Risk
            </Typography>

            <LinearProgress
              variant="determinate"
              value={riskScore}
              sx={{
                mt: 2,
                height: 8,
                borderRadius: 4,
                backgroundColor: "#FEF3C7",
                "& .MuiLinearProgress-bar": {
                  backgroundColor: "#f97316",
                },
              }}
            />
          </Box>

          {/* Insights */}
          <Stack spacing={1.5} mt={2}>
            <Box display="flex" gap={1} alignItems="center">
              <WarningAmber sx={{ color: "#f97316" }} />
              <Typography fontSize="13px">
                Temperature & signal instability
              </Typography>
            </Box>

            <Box display="flex" gap={1} alignItems="center">
              <TrendingUp sx={{ color: "#22c55e" }} />
              <Typography fontSize="13px">
                Risk increased <b>6%</b> this week
              </Typography>
            </Box>
          </Stack>

          {/* Footer */}
          <Chip
            label="Monitor Closely"
            size="small"
            sx={{
              mt: 2,
              alignSelf: "flex-start",
              backgroundColor: "#FFF7ED",
              color: "#f97316",
              fontWeight: 600,
            }}
          />
        </Card>

        <Card
          sx={{
            p: isMobile ? 3 : 2,
            borderRadius: 4,
            height: "430px",
            width: isMobile ? "100%" : "250px",
          }}
        >
          {/* Header */}
          <Typography fontWeight={700} fontSize="14px" mb={2}>
            NEXT 30 DAYS
          </Typography>

          {/* List */}
          <Stack spacing={2}>
            {next30DaysData.map((item, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  p: 1.5,
                  borderRadius: "12px",
                  backgroundColor: item.bg,
                }}
              >
                {/* Left */}
                <Box display="flex" gap={1.5} alignItems="center">
                  <Box
                    sx={{
                      width: 36,
                      height: 36,
                      borderRadius: "10px",
                      backgroundColor: "#ffffff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0px 2px 8px rgba(0,0,0,0.06)",
                    }}
                  >
                    {item.icon}
                  </Box>

                  <Box>
                    <Typography fontWeight={600} fontSize="13px">
                      {item.device}
                    </Typography>

                    <Typography fontSize="12px" color="text.secondary">
                      {item.location}
                    </Typography>

                    <Typography fontSize="11px" color="text.secondary">
                      {item.timeAgo}
                    </Typography>
                  </Box>
                </Box>

                {/* Right */}
                <Box textAlign="right">
                  <Typography
                    fontWeight={700}
                    fontSize="13px"
                    sx={{ color: item.percentColor }}
                  >
                    {item.percent}
                  </Typography>

                  <Typography fontSize="11px" color="text.secondary">
                    {item.schedule}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Stack>
        </Card>

        <Card
          sx={{
            mt: 3,
            p: 2,
            borderRadius: "16px",
            boxShadow: "0px 4px 16px rgba(0,0,0,0.06)",
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 1.5,
            }}
          >
            {/* Left: Title */}
            <Typography fontWeight={700} fontSize="14px">
              DEVICE EXPLORER
            </Typography>

            {/* Right: Filter Button */}
            <Button
              startIcon={<FilterList sx={{ fontSize: 18 }} />}
              size="small"
              variant="outlined"
              onClick={(e) => setAnchorEl(e.currentTarget)}
              sx={{
                textTransform: "none",
                borderRadius: "10px",
                fontSize: "13px",
                padding: "4px 12px",
                borderColor: "#e5e7eb",
                color: "#374151",
                backgroundColor: "#ffffff",
                "&:hover": {
                  backgroundColor: "#f9fafb",
                  borderColor: "#d1d5db",
                },
              }}
            >
              Filter
            </Button>

          </Box>
          {/* ===== STATUS FILTER TABS ===== */}

          {/* Table */}
          <TableContainer sx={{ overflowX: "auto" }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Device ID</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Building</TableCell>
                  <TableCell>Health</TableCell>
                  <TableCell>Signal</TableCell>
                  <TableCell>Temperature</TableCell>
                  <TableCell>Last Seen</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {filteredDevices.map((row, index) => (
                  <TableRow key={index} hover>
                    <TableCell>
                      <Typography fontWeight={600}>{row.id}</Typography>
                    </TableCell>

                    <TableCell>
                      <Chip
                        label={row.status}
                        sx={{
                          color: row.statusColor,
                          backgroundColor: row.statusBg,
                          fontWeight: 600,
                          fontSize: "12px",
                        }}
                      />
                    </TableCell>

                    <TableCell>{row.building}</TableCell>
                    <TableCell>{row.health}</TableCell>
                    <TableCell>{row.signal}</TableCell>
                    <TableCell>{row.temperature}</TableCell>
                    <TableCell>{row.lastSeen}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mt: 2,
            }}
          >
            <Pagination
              count={totalPages}
              page={page}
              onChange={(event, value) => setPage(value)}
              shape="rounded"
              siblingCount={1}
              boundaryCount={1}
              showFirstButton={false}
              showLastButton={false}
            />
          </Box>
          <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={() => setAnchorEl(null)}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <Box sx={{ p: 2, width: 280 }}>
              <Typography fontWeight={600} fontSize="14px" mb={1}>
                Filters
              </Typography>

              {/* ===== STATUS ===== */}
              <Typography fontSize="12px" fontWeight={600} mb={0.5}>
                Status
              </Typography>

              {["Good", "Fair", "Poor", "Critical"].map((status) => (
                <FormControlLabel
                  key={status}
                  control={
                    <Checkbox
                      size="small"
                      checked={statusFilter.includes(status)}
                      onChange={(e) =>
                        setStatusFilter((prev) =>
                          e.target.checked
                            ? [...prev, status]
                            : prev.filter((s) => s !== status)
                        )
                      }
                    />
                  }
                  label={<Typography fontSize="13px">{status}</Typography>}
                />
              ))}

              <Divider sx={{ my: 1.5 }} />

              {/* ===== BUILDING ===== */}
              <Typography fontSize="12px" fontWeight={600} mb={0.5}>
                Building
              </Typography>

              {["Building A", "Building B", "Building C", "Building D"].map(
                (building) => (
                  <FormControlLabel
                    key={building}
                    control={
                      <Checkbox
                        size="small"
                        checked={buildingFilter.includes(building)}
                        onChange={(e) =>
                          setBuildingFilter((prev) =>
                            e.target.checked
                              ? [...prev, building]
                              : prev.filter((b) => b !== building)
                          )
                        }
                      />
                    }
                    label={<Typography fontSize="13px">{building}</Typography>}
                  />
                )
              )}

              <Divider sx={{ my: 1.5 }} />

              {/* ===== LAST SEEN ===== */}
              <Typography fontSize="12px" fontWeight={600} mb={0.5}>
                Last Seen
              </Typography>

              <RadioGroup
                value={lastSeen}
                onChange={(e) => setLastSeen(e.target.value)}
              >
                {["15m", "1h", "offline"].map((v) => (
                  <FormControlLabel
                    key={v}
                    value={v}
                    control={<Radio size="small" />}
                    label={
                      <Typography fontSize="13px">
                        {v === "15m"
                          ? "Last 15 mins"
                          : v === "1h"
                            ? "Last 1 hour"
                            : "Offline"}
                      </Typography>
                    }
                  />
                ))}
              </RadioGroup>

              <Divider sx={{ my: 1.5 }} />

              {/* ===== TEMPERATURE ===== */}
              <Typography fontSize="12px" fontWeight={600} mb={0.5}>
                Temperature
              </Typography>

              <RadioGroup
                value={temperature}
                onChange={(e) => setTemperature(e.target.value)}
              >
                {["normal", "warning", "high"].map((t) => (
                  <FormControlLabel
                    key={t}
                    value={t}
                    control={<Radio size="small" />}
                    label={
                      <Typography fontSize="13px">
                        {t === "normal"
                          ? "Normal (< 40°C)"
                          : t === "warning"
                            ? "Warning (40–45°C)"
                            : "High (> 45°C)"}
                      </Typography>
                    }
                  />
                ))}
              </RadioGroup>

              <Divider sx={{ my: 1.5 }} />

              {/* ===== ACTIONS ===== */}
              <Box display="flex" gap={1}>
                <Button
                  fullWidth
                  variant="contained"
                  size="small"
                  sx={{ textTransform: "none" }}
                  onClick={() => {
                    setAppliedFilters({
                      status: statusFilter,
                      building: buildingFilter,
                      lastSeen,
                      temperature,
                    });
                    setAnchorEl(null); // close popover
                  }}
                >
                  Apply
                </Button>

                <Button
                  fullWidth
                  variant="outlined"
                  size="small"
                  sx={{ textTransform: "none" }}
                  onClick={() => {
                    // 1️⃣ Clear filter UI state
                    setStatusFilter([]);
                    setBuildingFilter([]);
                    setLastSeen("");
                    setTemperature("");

                    // 2️⃣ Clear applied filters (THIS UPDATES TABLE)
                    setAppliedFilters({
                      status: [],
                      building: [],
                      lastSeen: "",
                      temperature: "",
                    });

                    // 3️⃣ Reset tab to ALL
                    setTab("all");

                    // 4️⃣ Close popover
                    setAnchorEl(null);
                  }}
                >
                  Reset
                </Button>
              </Box>
            </Box>
          </Popover>

        </Card>
      </Grid>
    </Box>
  );
}
